var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleNotch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 256C496 388.344 388.344 496 256 496S16 388.344 16 256C16 150.172 83.875 58.016 184.906 26.719C197.562 22.828 211 29.875 214.938 42.531C218.844 55.203 211.75 68.641 199.094 72.563C118.281 97.609 64 171.328 64 256C64 361.875 150.125 448 256 448S448 361.875 448 256C448 171.312 393.719 97.594 312.906 72.562C300.25 68.641 293.156 55.203 297.062 42.531C301 29.922 314.531 22.844 327.094 26.719C428.125 58.016 496 150.156 496 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleNotch);
export default __webpack_public_path__ + "static/media/circle-notch.6bae7db0741b77f47dd5c21f950879ce.svg";
export { ForwardRef as ReactComponent };